window.$ = window.jQuery = require('jquery');
require('owl.carousel');

$(document).ready(function () {
    if ($('.js-page-template-business-services').length > 0) {
        var $partners = $('.js-customers-carousel');
        $partners.owlCarousel({
            loop: true,
            itemElement: 'div',
            autoplay: true,
            autoplayTimeout: 3000,
            navigation: false,
            autoHeight: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: false,
                    dots: true
                },
                480: {
                    items: 1,
                    nav: false,
                    dots: true
                },
                720: {
                    items: 4,
                    nav: false,
                    dots: true
                },
                1200: {
                    items: 6,
                    nav: false
                }
            }


        });

        $(".carousel-navigation.next").click(function () {
            $partners.trigger('next.owl.carousel');
            return false;
        });

        $(".carousel-navigation.prev").click(function () {
            $partners.trigger('prev.owl.carousel');
            return false;
        });
    }
})